import { TweenMax } from "gsap/TweenMax";
import isMobile from "../../plugins/is-mobile.js";

$(window).on("load", function () {
  if (!isMobile(768)) {
    $(".js-scrollerMain img").width($(window).width() * 0.742);
  } else {
    $(".js-scrollerMain img").width($(window).width());
  }
});

$(window).on("resize", function () {
  if (!isMobile(768)) {
    $(".js-scrollerMain img").width($(window).width() * 0.742);
  } else {
    $(".js-scrollerMain img").width($(window).width());
  }
});


//ロード時表示タイトル
const loadLogoItems = (!isMobile(590)) ? document.querySelectorAll(".js-logo-item") : document.querySelectorAll(".js-logo-item-sp");

loadLogoItems.forEach((loadLogoItem) => {
  TweenMax.to(loadLogoItem, -0.1, {
    y: 100,
    force3D: true,
    ease: Quint.easeOut,
  });
});

TweenMax.staggerTo(
  loadLogoItems,
  2,
  {
    y: 0,
    force3D: true,
    ease: Quint.easeOut,
  },
  0.15
);

//ロード時表示テキスト
const loadTexts = (!isMobile(768)) ? document.querySelectorAll(".js-grand-top-hero-text") : document.querySelectorAll(".js-grand-top-hero-text-sp");

loadTexts.forEach((loadText) => {
  TweenMax.to(loadText, -0.1, {
    y: 80,
    force3D: true,
    ease: Quint.easeOut,
  });
});

TweenMax.staggerTo(
  loadTexts,
  2,
  {
    y: 0,
    force3D: true,
    ease: Quint.easeOut,
    delay: 2.4
  },
  0
);

